/* eslint-disable no-shadow */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Loader } from 'component/Loader';
import { ToastContainer, toast } from 'react-toastify';

import { ReactComponent as ArrowIcon } from 'assets/images/icons/arrow_left.svg';
import { ReactComponent as MapIcon } from 'assets/images/icons/map3.svg';
import { ReactComponent as FilesIcon } from 'assets/images/icons/Files.svg';

import 'assets/styles/tabs.scss';
import { axiosWrapper } from 'utils/Helper';
import { getHAById } from 'api/HaApi';
import { useHAReports } from 'hooks/useHAReports';

import 'react-tabs/style/react-tabs.css';
import './styles.scss';

import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
} from 'react-accessible-accordion';

import { AccordionBodyItem, AccordionHeaderTitle } from 'component/Accordion';

import { getPhotoByName } from 'api/ImagesApi';
import { getDonorById } from 'api/DonorsApi';
import { getCustomerById } from 'api/CustomersApi';
import { ButtonComponent } from 'component/Button';
import { useUser } from 'routes/UserContext';
import { REPORT_TYPES } from 'consts/ReportValidation';
import { CommentBlock, CommentDisplay, handleReportValidation } from 'component/CommentBlock';
import { ReactComponent as TranslateSvg } from 'assets/images/icons/translate_24px.svg';
import { TranslateWrapperComponent } from 'component/Translation';
import { useValidationComments } from 'hooks/useValidationComments';
import { FileInformation } from '../blocks/FileInformation';
import { MapInfo } from '../blocks/MapInfo';
import { GeneralInfoView } from '../ViewBlocks/GeneralInfo/GeneralInfo';
import { LocationView } from '../ViewBlocks/Location/Location';
import { ContaminationView } from '../ViewBlocks/Contamination/Contamination';
import { EvidencesView } from '../ViewBlocks/Evidences/Evidences';
import { FileInfoView } from '../ViewBlocks/FileInfo/FileInfo';
import { GeographicView } from '../ViewBlocks/Geographic/Geographic';
import { LandRelease } from '../ViewBlocks/LandRelease/LandRelease';
import { BeneficiariesView } from '../ViewBlocks/Beneficiaries/Beneficiaries';
import { InformatorsView } from '../ViewBlocks/Informators/Informators';
import { PhotosView } from '../ViewBlocks/Photos/Photos';
import { AnnexMapView } from '../ViewBlocks/AnnexMap/AnnexMap';
import { rejectHaReport, localRejectHaReport } from '../../../api/HaApi';
import { HAformData } from '../../../consts/Forms';
import { CommentsFromImsmaView } from '../ViewBlocks/Comments';

const ViewHAReportPage = ({ mode }) => {
  const [formData, setFormData] = useState(HAformData);
  const [loader, setLoader] = useState(true);

  const [map, setMap] = useState(null);
  const [map1, setMap1] = useState(null);
  const [map2, setMap2] = useState(null);
  const [turnPointsMap, setTurnPointsMap] = useState(null);

  const [annexImages, setAnnexImages] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [translatedFormData, setTranslatedFormData] = useState([]);
  const [translateState, setTranslateState] = useState(false);
  const [prefetchedDonorName, setPrefetchedDonorName] = useState(undefined);
  const [prefetchedCustomerName, setPrefetchedCustomerName] = useState(undefined);


  const haReportsMain = useHAReports(map);
  const haReportsDirect = useHAReports(map1);
  const haReportsIndirect = useHAReports(map2);
  const haReportsFileInfo = useHAReports(turnPointsMap);

  const { reportId } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
    document.title = mode === 'validation'
      ? `Validation HA report - ${formData?.info?.general?.hazard_name || 'Unknow'}`
      : `View HA report - ${formData?.info?.general?.hazard_name || 'Unknow'}`;
  }, [formData]);

  const photosRef = useRef([]);
  const annexImagesRef = useRef([]);
  photosRef.current = photos;
  annexImagesRef.current = annexImages;
  useEffect(() => {
    return () => {
      photosRef.current.forEach((p) => { if (p?.data_url) URL.revokeObjectURL(p.data_url); });
      annexImagesRef.current.forEach((p) => { if (p?.data_url) URL.revokeObjectURL(p.data_url); });
    };
  }, []);

  const commentsData = useValidationComments(REPORT_TYPES.HA, reportId);
  const {
    comments,
    commentForm,
    savedComment,
    commentEntered,
    onSaveComment,
    onDeleteComment,
    handleComments,
    resetCommentForm,
  } = commentsData;

  const getAnnexImage = (reportId, imageFile) => {
    if (!imageFile || !imageFile.file_name) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      axiosWrapper(() => {
        getPhotoByName(reportId, imageFile.file_name, true)
          .then((res) => {
            if (res.status === 200) {
              const image = new File([res.data], imageFile.file_name, {
                type: 'image/jpeg',
              });

              setAnnexImages((prevPhotos) => [
                ...prevPhotos,
                {
                  file: image,
                  data_url: URL.createObjectURL(res.data),
                  file_name: imageFile.file_name,
                  is_main: imageFile.is_main,
                },
              ]);
              resolve();
            } else {
              reject('Annex maps request failed');
            }
          })
          .catch((err) => {
            toast.error('Annex maps not loaded');
            reject(err);
          });
      });
    });
  };

  const getAnnexImages = (res) => new Promise((resolve) => {
    const promises = [];

    res.data.info.annex?.items?.forEach((item) => {
      promises.push(getAnnexImage(res.data.id, item));
    });

    Promise.all(promises)
      .then(() => {
        resolve('ok');
      })
      .catch(() => {
        toast.error('Annex maps not loaded');
      });
  });

  const getPhoto = (reportId, imageFile, dependency, item) => {
    if (!imageFile || !imageFile.file_name) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      axiosWrapper(() => {
        getPhotoByName(reportId, imageFile.file_name)
          .then((res) => {
            if (res.status === 200) {
              const image = new File([res.data], imageFile.file_name, {
                type: 'image/jpeg',
              });

              setPhotos((prevPhotos) => [
                ...prevPhotos,
                {
                  file: image,
                  data_url: URL.createObjectURL(res.data),
                  name: imageFile.file_name,
                  dependency,
                  item,
                  description: imageFile.description || '',
                  lat: imageFile.lat || '',
                  long: imageFile.long || '',
                  date: imageFile.date || '',
                },
              ]);

              resolve();
            } else {
              reject('Photo request failed');
            }
          })
          .catch((err) => {
            toast.error(
              `Photo with file name ${imageFile.file_name} not loaded`,
            );
            reject(err);
          });
      });
    });
  };
  const getAllPhotos = (res) => new Promise((resolve) => {
    const promises = [];

    res.data.info.general_photos.items?.forEach((item) => {
      promises.push(getPhoto(res.data.id, item, 'general', null));
    });

    res.data.info.evidences.direct_evidences.items?.forEach((item, index) => {
      if (!item.photo) return;
      item.photo?.forEach((photo) => {
        promises.push(
          getPhoto(res.data.id, photo, 'direct_evidence', index + 1),
        );
      });
    });

    res.data.info.evidences.indirect_evidences.items?.forEach(
      (item, index) => {
        if (!item.photo) return;
        item.photo?.forEach((photo) => {
          promises.push(
            getPhoto(res.data.id, photo, 'indirect_evidence', index + 1),
          );
        });
      },
    );

    if (res.data.info.lm.photo.length > 0) {
      res.data.info.lm.photo.forEach((photo) => {
        promises.push(getPhoto(res.data.id, photo, 'lm', null));
      });
      res.data.info.bm.photo.forEach((photo) => {
        promises.push(getPhoto(res.data.id, photo, 'bm', null));
      });
    } else {
      promises.push(getPhoto(res.data.id, res.data.info.lm.photo, 'lm', null));
      promises.push(getPhoto(res.data.id, res.data.info.bm.photo, 'bm', null));
    }

    Promise.allSettled(promises)
      .then(() => {
        resolve('ok');
      })
      .catch(() => {
        toast.error('Photos not loaded');
      });
  });

  const PageTitle = (props) => (
    <div className="page-title">
      <ArrowIcon
        onClick={() => navigate(-1)}
        style={{ cursor: 'pointer' }}
      />
      <div>{props.title}</div>
      <span className="blue-text">
        |
        {props.name}
      </span>
    </div>
  );

  const handleRejectButton = (status) => {
    setLoader(true);
    rejectHaReport(formData.id, { status })
      .then(() => {
        toast.success('HA report rejected from IMSMA');
        setLoader(false);
        setTimeout(() => {
          navigate('/nts-ha-report');
        }, 2000);
      })
      .catch(() => {
        toast.error('Error rejecting HA report from IMSMA');
        setLoader(false);
      });
  };

  const handleLocalRejectButton = (status) => {
    setLoader(true);
    localRejectHaReport(formData?.id, { status })
      .then(() => {
        toast.success('HA report rejected from DMS');
        setLoader(false);
        setTimeout(() => {
          navigate('/nts-ha-report');
        }, 2000);
      })
      .catch(() => {
        toast.error('Error rejecting HA report from DMS');
        setLoader(false);
      });
  };

  const handleValidation = (status, event) => handleReportValidation(
    status,
    event,
    `/validations/ha/${reportId}/`,
    '/nts-ha-report',
    setLoader,
    savedComment,
    resetCommentForm,
    navigate,
  );


  useEffect(() => {
    const controller = new AbortController();
    getHAById(reportId, false, false, controller.signal)
      .then((res) => {
        if (res.status === 200) {
          setFormData(res.data);
          const data = res.data.info || {};

          const rawDonorId = data.general?.donor ?? res.data?.donor;
          const donorId = rawDonorId && typeof rawDonorId === 'object'
            ? (rawDonorId?.value ?? rawDonorId?.id)
            : rawDonorId;
          const customerId = data.general?.task_customer ?? res.data?.task_customer;

          if (donorId) {
            getDonorById(donorId)
              .then((r) => setPrefetchedDonorName(r?.data?.name ?? null))
              .catch(() => setPrefetchedDonorName(null));
          } else {
            setPrefetchedDonorName(null);
          }
          if (customerId) {
            getCustomerById(customerId)
              .then((r) => setPrefetchedCustomerName(r?.data?.name ?? null))
              .catch(() => setPrefetchedCustomerName(null));
          } else {
            setPrefetchedCustomerName(null);
          }

          const hasAnnex = data.annex?.items?.length > 0;
          const hasPhotos = data.general_photos?.items?.length > 0
            || data.evidences?.direct_evidences?.items?.some((i) => i.photo?.length)
            || data.evidences?.indirect_evidences?.items?.some((i) => i.photo?.length)
            || (data.lm?.photo && (Array.isArray(data.lm.photo) ? data.lm.photo.length > 0 : data.lm.photo?.file_name))
            || (data.bm?.photo && (Array.isArray(data.bm.photo) ? data.bm.photo.length > 0 : data.bm.photo?.file_name));
          if (hasAnnex) getAnnexImages(res);
          if (hasPhotos) getAllPhotos(res);
          setLoader(false);
        }
      })
      .catch((err) => {
        if (err?.code === 'ERR_CANCELED') return;
        console.error(err);
        setLoader(false);
      });
    return () => controller.abort();
  }, []);

  return (
    <section>
      <PageTitle
        title={`${mode === 'validation' ? 'Validation' : 'View'} HA Report`}
        name={formData?.info?.general?.hazard_name || 'Unknown'}
        navigate={navigate}
      />
      <TranslateWrapperComponent
        formData={formData}
        setTranslatedFormData={setTranslatedFormData}
        translationState={translateState}
      >
        <form className="form-wrapper">
          <div
            className="text-hover flex-group flex-right"
            onClick={() => setTranslateState(!translateState)}
          >
            <TranslateSvg />
            <span>Translate</span>
          </div>
          <div className="info_block_header">
            <div className="info_block_header_left">Атрибути</div>
            <span className="info_block_header_line" />
            <div className="info_block_header_right">Attributes</div>
          </div>

          <Accordion
            allowMultipleExpanded
            allowZeroExpanded
            preExpanded={[
              'general',
              'location',
              'contamination',
              'evidence',
              'fileInfo',
              'geographic',
              'landrelease',
              'beneficiaries',
              'informators',
            ]}
            className="custom-accordion"
          >
            {(mode === 'validation' || mode === 'view') && <CommentsFromImsmaView comments={comments} />}
            {!formData?.report_sent_to_imsma && formData?.info?.general?.hasOwnProperty('from_existing_ha_report') &&(
                    <div style={{width: '45%', marginTop: '-20px'}}>
                      <AccordionBodyItem
                        accordionSubId={(
                          <div>
                          </div>
                        )}
                        titleUA="Тип звіту"
                        titleEN="Report type"
                        children={(
                          <div className="flex-group no-wrap">
                            <>
                              <div>
                                {formData?.info?.general?.from_existing_ha_report ?
                                  "Оновлений / Updated" :
                                  "Новий / New"
                                }
                              </div>
                            </>
                          </div>
                        )}
                      />
                    </div>
                      )}
            <GeneralInfoView
              formData={formData}
              comments={[]}
              translatedFormData={translatedFormData}
              translateState={translateState}
              prefetchedDonorName={prefetchedDonorName}
              prefetchedCustomerName={prefetchedCustomerName}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="general"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="general" />
            )}
            <LocationView
              formData={formData}
              comments={[]}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="location"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="location" />
            )}
            <ContaminationView
              formData={formData}
              comments={[]}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="contamination"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="contamination" />
            )}
            <EvidencesView
              formData={formData}
              comments={[]}
              map1={map1}
              setMap1={setMap1}
              map2={map2}
              setMap2={setMap2}
              translatedFormData={translatedFormData}
              translateState={translateState}
              haReportsDirect={haReportsDirect}
              haReportsIndirect={haReportsIndirect}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="evidences"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="evidences" />
            )}
            <FileInfoView
              formData={formData}
              comments={[]}
              turnPointsMap={turnPointsMap}
              setTurnPointsMap={setTurnPointsMap}
              translatedFormData={translatedFormData}
              translateState={translateState}
              haReports={haReportsFileInfo}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="polygon_info"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="polygon_info" />
            )}
            <GeographicView
              formData={formData}
              comments={[]}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="geographic_and_terrain_description"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="geographic_and_terrain_description" />
            )}
            <LandRelease
              formData={formData}
              comments={[]}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="next_landrelease_activity"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="next_landrelease_activity" />
            )}
            <BeneficiariesView
              formData={formData}
              comments={[]}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="landuse_and_beneficiaries"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="landuse_and_beneficiaries" />
            )}
            <InformatorsView
              formData={formData}
              comments={[]}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
            {mode === 'validation' && (
              <CommentBlock
                comments={comments}
                savedComment={savedComment}
                commentForm={commentForm}
                commentEntered={commentEntered}
                block="informators"
                onDeleteComment={onDeleteComment}
                handleComments={handleComments}
                onSaveComment={onSaveComment}
              />
            )}
            {mode === 'view' && (
            <CommentDisplay comments={comments} block="informators" />
            )}
          </Accordion>
          <div className="info_block_header">
            <div className="info_block_header_left">ГІС</div>
            <span className="info_block_header_line" />
            <div className="info_block_header_right">Gis</div>
          </div>

          <Accordion
            allowMultipleExpanded
            allowZeroExpanded
            preExpanded={['fileInfo', 'evidenceInfo', 'map', 'annexMaps']}
            className="custom-accordion"
          >
            <AccordionItem uuid="fileInfo">
              <FileInformation
                formData={formData}
                accordionId={<FilesIcon style={{ color: '#00b1b7' }} />}
                tab="gis"
              />
            </AccordionItem>

            <AccordionItem uuid="map">
              <MapInfo
                formData={formData}
                accordionId={<MapIcon />}
                map={map}
                setMap={setMap}
                evidences={formData?.info?.evidences}
                haReports={haReportsMain}
              />
              {mode === 'validation' && (
                <CommentBlock
                  comments={comments}
                  savedComment={savedComment}
                  commentForm={commentForm}
                  commentEntered={commentEntered}
                  block="map"
                  onDeleteComment={onDeleteComment}
                  handleComments={handleComments}
                  onSaveComment={onSaveComment}
                />
              )}
              {mode === 'view' && (
            <CommentDisplay comments={comments} block="map" />
            )}
            </AccordionItem>
          </Accordion>
          <div className="info_block_header">
            <div className="info_block_header_left">Фото</div>
            <span className="info_block_header_line" />
            <div className="info_block_header_right">Photos</div>
          </div>
          <Accordion
            className="custom-accordion"
            allowMultipleExpanded
            allowZeroExpanded
          >
            <AccordionItem uuid="photos">
              <AccordionItemHeading>
                <AccordionItemButton>
                  <AccordionHeaderTitle titleUA="Фото" titleEN="Photo" />
                </AccordionItemButton>
              </AccordionItemHeading>

              <PhotosView photos={photos} />
            </AccordionItem>
          </Accordion>
          <Accordion
            className="custom-accordion"
            allowMultipleExpanded
            allowZeroExpanded
          >
            <AccordionItem uuid="annexMaps">
              <AccordionItemHeading>
                <AccordionItemButton>
                  <AccordionHeaderTitle titleUA="Annex Maps" />
                </AccordionItemButton>
              </AccordionItemHeading>

              <AnnexMapView annexImages={annexImages} />
            </AccordionItem>
          </Accordion>
          {mode === 'view' && (
            <div className="form-buttons buttons-group py-10">
              {
                formData?.validation_status?.value === 'validated'
                && user?.permissions?.reject_imsma_nto_ha
                && formData?.send_to_imsma
                && (
                  <ButtonComponent
                    handleButton={() => {
                      handleRejectButton('rejected');
                    }}
                    label="Reject from IMSMA"
                    disabled={false}
                    className="danger"
                    type="button"
                  />
                )
              }
              {
                formData?.validation_status?.value === 'validated'
                && user?.permissions?.reject_imsma_nto_ha
                && !formData?.send_to_imsma
                && (
                  <ButtonComponent
                    handleButton={() => {
                      handleLocalRejectButton('rejected');
                    }}
                    label="Reject from DMS"
                    disabled={false}
                    className="danger"
                    type="button"
                  />
                )
              }
            </div>
          )}
          {mode === 'validation'
            && (
              <div className="form-buttons buttons-group py-10">
                <ButtonComponent
                  handleButton={(event) => handleValidation('rejected', event)}
                  label="Reject"
                  disabled={!Object.values(savedComment).some((comment) => comment && comment.trim() !== '')}
                  className="danger"
                  type="button"
                />
                <ButtonComponent
                  handleButton={(event) => handleValidation('accepted', event)}
                  label="Accept"
                  disabled={false}
                  type="button"
                />
              </div>
            )}
        </form>
      </TranslateWrapperComponent>

      <Loader visible={loader} />
      <ToastContainer />
    </section>
  );
};

export default ViewHAReportPage;
